import Head from "next/head";
import getConfig from "next/config";
import Link from "next/link";
import Breadcrumbs from "@components/Breadcrumbs";
import ResponsiveHeroBanner from "@components/ResponsiveHeroBanner";
import LegoByAge from "@components/LegoByAge";
import LegoByPassion from "@components/LegoByPassion";
import LegoByTheme from "@components/LegoByTheme";
import LegoWizard from "@components/LegoWizard";
import LegoPromoCategories from "@components/LegoPromoCategories";
import ErrorPage from "@containers/ErrorPage";
import { makeApiCall } from "@lib/api/helpers";
import { getBannersV2Api } from "@lib/api";
import transformV2Banners from "@lib/transformV2Banners";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const LegoUniverse = ({ notFound, heroBanner }) => {
  if (notFound) {
    return <ErrorPage layout="404" />;
  }

  const hasHeroBanner = heroBanner && heroBanner.position === "CONTENT_TOP";

  return (
    <>
      <Head>
        <title>Universul LEGO®</title>
      </Head>

      <Breadcrumbs
        breadcrumbs={[
          {
            id: 1,
            level: 99,
            name: "Universul LEGO®",
          },
        ]}
      />

      {hasHeroBanner && (
        <div className="mb-12 mx-auto">
          <ResponsiveHeroBanner banner={heroBanner} />
        </div>
      )}

      <div className="bg-gray-100 mb-16 px-8 pt-10 pb-12 -mx-4 sm:mx-0 sm:rounded-tr-lg sm:rounded-bl-lg">
        <LegoWizard />
      </div>

      <div className="mb-16">
        <LegoPromoCategories />
      </div>

      <div className="mb-16">
        <LegoByAge />
      </div>

      <div className="mb-16">
        <LegoByPassion />
      </div>

      <div className="mb-16">
        <LegoByTheme />
      </div>

      <Link href={`${settings.baseUrl}/lego-adulti/pag/`}>
        <a title="">
          <img
            className="hidden md:block"
            src={`${settings.websiteStatics}/images/universul-lego/descopera-un-nou-mod-de-a-te-destinde.png`}
            alt=""
          />

          <img
            className="md:hidden"
            src={`${settings.websiteStatics}/images/universul-lego/descopera-un-nou-mod-de-a-te-destinde-mobile.png`}
            alt=""
          />
        </a>
      </Link>
    </>
  );
};

LegoUniverse.getInitialProps = async ({ res }) => {
  if (
    settings.websiteName === "mediagalaxy" ||
    settings.websiteName === "bricostore"
  ) {
    if (res) res.statusCode = 404;

    return {
      notFound: true,
    };
  }

  const heroBanner = await makeApiCall({
    apiCall: getBannersV2Api,
    apiArgs: [{ id: 44 }],
    formatResponse: (response) => response.data,
    returnResponse: true,
  });

  if (heroBanner) {
    return {
      heroBanner: transformV2Banners(heroBanner),
    };
  }
};

LegoUniverse.pageLayout = "default";

export default LegoUniverse;
